import { useQuery } from '@tanstack/react-query';
import { getCalendarErrorLogs } from '@/api/calendar/errorLogs';

export const CalendarWorkflowErrorLogs: React.FC<{
	workFlowForErrorLogs: { workflowName: string; forwardedFrom: string };
}> = ({ workFlowForErrorLogs }) => {
	const { data: errorLogs } = useQuery({
		queryKey: ['calendarErrorLogs', workFlowForErrorLogs],
		enabled: !!workFlowForErrorLogs,
		queryFn: () => getCalendarErrorLogs(workFlowForErrorLogs.workflowName),
	});

	const sortedLogs = errorLogs?.sort(
		(a, b) =>
			new Date(parseInt(b.timestamp as unknown as string)).getTime() -
			new Date(parseInt(a.timestamp as unknown as string)).getTime(),
	);

	return (
		<div className="mb-8 bg-gray-100 p-6 rounded">
			<h2 className="text-2xl font-semibold mb-4 text-gray-800">
				Error Logs for {workFlowForErrorLogs.workflowName}
			</h2>
			<div className="h-64 overflow-auto">
				{sortedLogs && sortedLogs.length > 0 ? (
					<ul className="list-disc pl-5">
						{sortedLogs.map((log: any, index: number) => (
							<li key={index} className="mb-2">
								<div className="text-gray-500">
									<strong>Time:</strong>{' '}
									{new Date(parseInt(log.timestamp as unknown as string)).toLocaleString()}
								</div>
								<div className="text-gray-500">
									<strong>Request URL:</strong> {log.response?.data?.path || 'Unknown path'}
								</div>
								<div className="text-gray-700">
									<strong>Error:</strong> {log.response?.data?.error?.message || 'Unknown error'}
								</div>
								{log.context?.stack && (
									<div className="text-gray-600 mt-2">
										<strong>Stack Trace:</strong>
										<pre className="mt-1 text-xs bg-gray-200 p-2 rounded overflow-x-auto">
											{log.context.stack}
										</pre>
									</div>
								)}
								{index < sortedLogs.length - 1 && <hr className="my-4 border-2" />}
							</li>
						))}
					</ul>
				) : (
					<p className="text-gray-500">No error logs available.</p>
				)}
			</div>
		</div>
	);
};
